import React from 'react';
import HistoryIcon from '@material-ui/icons/History';


export const BtnHistoryCargoShipment = (props) => {
    return (
        <button
            className="button-action"
            onClick={props.onClickOpenHistoryPage}
            title={props.title}
            style={{
                marginRight: ".25em",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.25em" // Espaço entre ícone e texto (opcional)
            }}
        >
            <HistoryIcon /> {props.label}
        </button>
    )
}